import { render, staticRenderFns } from "./AlunoClasseGeral.vue?vue&type=template&id=72396f6e&"
import script from "./AlunoClasseGeral.vue?vue&type=script&lang=js&"
export * from "./AlunoClasseGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports